import _defineProperty from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import configMenu from '../configMenu.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
import { isEmpty, guid } from '@/utils';
export default {
  name: 'bottom_config',
  components: {
    draggable: draggable,
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary,
    configMenu: configMenu
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    categoryMode: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 是否显示分类页模式选项,
    childrenMenuList: Array,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array,
    customerPackageList: Array,
    systemMenus: Object,
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      rules: {
        bg_type: [{
          required: true,
          message: '请选择背景类型',
          trigger: 'change'
        }],
        bg_color: [{
          required: true,
          message: '背景色不可为空',
          trigger: 'change'
        }],
        bg_img: [{
          required: true,
          message: '背景图不可为空',
          trigger: 'change'
        }]
      },
      showPictureLibrary: false,
      pictureInfo: {},
      pictureList: [],
      depot: {},
      updateIndex: 0,
      pictureIndex: 1,
      updateProp: '',
      explainList: [{
        key: 'small',
        label: '图文小图模式：默认风格-图标尺寸40*40px'
      }, {
        key: 'pic',
        label: '全图模式：分类下支持上传图片：宽142px高76px'
      }, {
        key: 'big',
        label: '图文大图模式：节日专属-图标尺寸50*50px'
      }]
    };
  },
  methods: {
    jumpCategory: function jumpCategory() {
      var _this$$router$resolve = this.$router.resolve({
          path: "/custom-layout/category",
          query: _objectSpread({}, this.$route.query)
        }),
        href = _this$$router$resolve.href;
      window.open(href, '_blank');
    },
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureInfo = picture;
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      if (this.updateProp === 'bg_img') {
        this.value.config.bg_img = path;
      } else {
        this.value.config.value[this.updateIndex][this.updateProp] = path;
      }
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(pictureIndex, prop, index) {
      this.pictureIndex = pictureIndex; // 图库索引
      this.updateIndex = index; // 更新元素索引
      this.updateProp = prop; // 更新属性
      this.pictureList = this.pictureInfo[this.pictureIndex];
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(index) {
      if (typeof index === 'number') {
        this.$refs.uploadBanner[index].uploadBanner();
      } else {
        this.$refs[index].uploadBanner();
      }
    },
    delImg: function delImg(item, prop) {
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        item[prop] = '';
      }).catch(function () {});
    },
    changeType: function changeType(item) {
      item.link_value = '';
    },
    delClassify: function delClassify(index) {
      var _this2 = this;
      this.$confirm('确认要删除该菜单吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: function callback(action) {
          if (action === 'confirm') {
            _this2.value.config.value.splice(index, 1);
          }
        }
      });
    },
    // 添加分类
    addClassify: function addClassify() {
      var initValue = {
        flag: true,
        type: 'normal',
        link_type: '1',
        link_value: '',
        name: "\u65B0\u589E\u83DC\u5355",
        name_alias: "\u65B0\u589E\u83DC\u5355",
        goods_id: '',
        module_plate_id: '',
        style: '1',
        font_size: 26,
        font_color: '#606266',
        active_font_color: '#c20c0c',
        uid: guid()
      };
      var keys = [].concat(_toConsumableArray(Object.keys(this.value.config.value[0])), _toConsumableArray(Object.keys(initValue)));
      var obj = keys.reduce(function (prev, cur) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, cur, initValue[cur] || ''));
      }, {});
      this.value.config.value.push(obj);
    },
    emitUploadFile: function emitUploadFile(res, item, prop) {
      item[prop] = "".concat(this.$ossurl).concat(res);
    },
    checkFlag: function checkFlag(rule, value, callback) {
      var showTabs = this.value.config.value.filter(function (i) {
        return Boolean(i.flag);
      });
      if (showTabs.length < 1) {
        callback('至少选一个菜单展示到首页');
      } else if (showTabs.length > 5) {
        callback('导航菜单最多展示五个');
      } else {
        callback();
      }
    },
    changeSwitch: function changeSwitch() {
      this.$refs.form.validate();
    }
  },
  created: function created() {
    var _this3 = this;
    if (isEmpty(this.value.config)) {
      var value = this.value.config_default_value.value.map(function (i) {
        return _objectSpread(_objectSpread({}, i), _this3.categoryMode && i.type === 'category' ? _this3.value.config_default_value.menus_page : {});
      });
      this.$set(this.value.config, 'value', value);
    }
    this.value.config.value = this.value.config.value.map(function (i) {
      var link_type = i.link_type,
        _i$goods_id = i.goods_id,
        goods_id = _i$goods_id === void 0 ? '' : _i$goods_id,
        _i$module_plate_id = i.module_plate_id,
        module_plate_id = _i$module_plate_id === void 0 ? '' : _i$module_plate_id,
        _i$style = i.style,
        style = _i$style === void 0 ? '1' : _i$style,
        _i$font_size = i.font_size,
        font_size = _i$font_size === void 0 ? 26 : _i$font_size,
        _i$font_color = i.font_color,
        font_color = _i$font_color === void 0 ? '#606266' : _i$font_color,
        _i$active_font_color = i.active_font_color,
        active_font_color = _i$active_font_color === void 0 ? '#c20c0c' : _i$active_font_color;
      return _objectSpread(_objectSpread({}, i), {}, {
        link_type: link_type + '',
        goods_id: goods_id,
        module_plate_id: module_plate_id,
        style: style,
        font_size: font_size,
        font_color: font_color,
        active_font_color: active_font_color,
        uid: guid()
      });
    });
    this.$set(this.value, 'config', _objectSpread({
      bg_type: '1',
      // 背景类型 1：颜色 2：图片
      bg_color: '#ffffff',
      bg_img: ''
    }, this.value.config));
    this.getPicture();
  }
};